module.exports = __webpack_public_path__ + "static/assets/e73c3c9d236267ba684bc3817e62ae5f.svg";